export const FEATURE_FLAGS = {
  displayCreditMemoDownload: 'displayCreditMemoDownload',
  manageInvoicesCreditMemosEnabled: 'manageInvoicesCreditMemosEnabled',
} as const;